/**
 * PrivacyChoicesLink — persistent link to the tracking opt-out control.
 *
 * Tracking on the scanner app is opt-out (CCPA/CPRA): the ad/analytics
 * trackers in public/index.html load by default and are suppressed only by an
 * explicit `privisy_consent=false` or a GPC signal. CCPA requires the opt-out
 * mechanism to stay reachable, and this app has no footer — App.tsx renders a
 * separate shell per route — so this sits at the app root, in the slot the
 * removed ConsentBanner used to occupy. Bottom-left, to stay clear of the
 * Tawk.to chat launcher in the bottom-right corner.
 */
import React from 'react';
import { T, withAlpha } from '../designTokens';

export default function PrivacyChoicesLink() {
  return (
    <a
      className="no-print"
      href="https://getprivisy.com/your-privacy-choices"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '12px',
        left: '12px',
        zIndex: 90,
        padding: '5px 12px',
        borderRadius: T.radiusFull,
        backgroundColor: withAlpha(T.gray900, 0.85),
        border: `1px solid ${withAlpha(T.white, 0.16)}`,
        color: T.gray300,
        fontSize: '12px',
        fontFamily: T.fontMono,
        fontWeight: 500,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        lineHeight: 1.2,
        textDecoration: 'none',
        backdropFilter: 'blur(4px)',
      }}
    >
      Your Privacy Choices
    </a>
  );
}
